import React from 'react'
import { connect }  from "react-redux";
import { pricingActions, currencyActions, alertActions } from "_actions";
import PaymentForm from 'components/Payments/PaymentForm'

class CreatePricing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pricingData: {
                currency: '',
                amount: '',
                label: '',
            },
            submitting: false,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(currencyActions.getAll())
    }

    handleChange = (event) => {
        const { target: {name, value}} = event
        this.setState(prevState => ({
            pricingData: {
                ...prevState.pricingData,
                [name]: value
            }
        }))
    }

    handleSubmit = (event) => {
        event.preventDefault()
        const { pricingData } = this.state
        const { dispatch } = this.props
        if (! pricingData.currency || ! pricingData.amount || !pricingData.label) {
            dispatch(alertActions.error('All Form Fields are required'))
            return
        }
        this.setState({ submitting: true })
        dispatch(pricingActions.createPricing(pricingData))
    }

    render() {
        const { currencies } = this.props
        const { pricingData, submitting } = this.state

        return (
            <div className="main-content-wrapper top-rel-100 margin-0-40">
                <PaymentForm
                    title="Create Pricing Rate"
                    formData={pricingData}
                    currencies={currencies}
                    submitting={submitting}
                    url="/pricing-rates"
                    actionType="Create"
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { currency: { all_currency } } = state;

    return {
        currencies: all_currency
    };
}

const createPricingPage = connect(mapStateToProps)(CreatePricing);
export { createPricingPage as CreatePricing };